import { Tabs } from 'antd';
import ExamBooking from './ExamBooking';
import ExamHistory from './ExamHistory';
import ExamSummary from './ExamSummary';

const Exams = () => {
  return (
    <Tabs
      items={[
        {
          key: 'booking',
          label: '考试预约',
          children: <ExamBooking />,
        },
        {
          key: 'history',
          label: '考试记录',
          children: <ExamHistory />,
        },
        {
          key: 'summary',
          label: '考试统计',
          children: <ExamSummary />,
        }
      ]}
    />
  );
};

export default Exams;